<template>
	<div class="flex items-center">
		<slot />

		<Transition v-bind="tooltipTransition">
			<Badge
				v-show="showTooltip"
				:variant="badgeVariant"
				class="ml-2 w-fit text-xs font-medium"
			>
				{{ tooltipText }}
			</Badge>
		</Transition>
	</div>
</template>

<script setup lang="ts">
import Badge from '../badge/Badge.vue';
import type { TooltipButtonProps } from '.';

withDefaults(defineProps<TooltipButtonProps>(), {
	badgeVariant: 'primary',
	showTooltip: false
});

const opacityZeroClass = 'opacity-0';
const opacityFullClass = 'opacity-100';
const transitionDefaultClass = 'transition-opacity duration-300  ease-in-out';

const tooltipTransition = {
	enterActiveClass: transitionDefaultClass,
	enterFromClass: opacityZeroClass,
	enterToClass: opacityFullClass,
	leaveActiveClass: transitionDefaultClass,
	leaveFromClass: opacityFullClass,
	leaveToClass: opacityZeroClass
};
</script>
